<template>
  <v-chip-group id="tract-table-filter-chips">
    <v-chip
    v-for="f in filtersView"
    class="tract-table-filter-chip"
    :key="f.name"
    color="secondary"
    text-color="white"
    close @click:close="removeFilter(f)"
    :small="$vuetify.breakpoint.lgAndDown">
      <span v-if="f.filterType === 'status'">
        <Icon
        :icon="TractStatus.forInt(f.status).details.icon"
        :iconColor="colorForTractStatus(f)" />
        {{ f.name }}
      </span>

      <span v-else>
        <v-icon small class="mr-1">{{ IconHelpers.getIconForObjectType(f.filterType) }}</v-icon>
        {{ f.name }}
      </span>
    </v-chip>
  </v-chip-group>
</template>

<script>
import { TractStatus } from '@/utils/Enumerations.js'
import IconHelpers from '@/utils/IconHelpers'

export default {
  name: 'TractFilterChips',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    filter: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    TractStatus,
    IconHelpers
  }),

  computed: {
    filtersView () {
      let result = []
      if (this.filter.myTracts) result = result.concat({ filterType: 'myTracts', name: this.$t('myTracts') })
      const statuses = this.filter.status.map(s => ({ filterType: 'status', name: TractStatus.fromInt(s), status: s }))
      const tractTypes = this.filter.selectedTractTypes.map(tt => ({ filterType: 'tractType', name: tt.name }))
      const harvestTypes = this.filter.selectedHarvestTypes.map(ht => ({ filterType: 'harvestType', name: ht.name }))
      const loggingMethods = this.filter.selectedLoggingMethods.map(lm => ({ filterType: 'loggingMethod', name: lm.name }))
      const foresters = this.filter.selectedForesters.map(f => ({ filterType: 'forester', name: f.name }))
      const teams = this.filter.selectedTeams.map(t => ({ filterType: 'team', name: t.name }))
      result = result.concat(statuses)
        .concat(tractTypes)
        .concat(harvestTypes)
        .concat(loggingMethods)
        .concat(foresters)
        .concat(teams)
      return result
    }
  },

  methods: {
    removeFilter (f) {
      this.$emit('remove-filter', f)
    },

    colorForTractStatus ({ status }) {
      const color = TractStatus.forInt(status).details.color
      if (color !== 'secondary') return color
      return 'white'
    }
  }
}
</script>
